import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import ErrorPage from '../components/common/ErrorPage';

import TrainingSetDetails from '../components/train/details/TrainingSetDetails';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import { useParams } from 'react-router';
import { DocumentContextProvider } from '../context/DocumentContext';
import useUserInfo from '../components/hooks/useUserInfo';

const TrainingSetDetailsPage = () => {
  const { dpid, id: tsId } = useParams<{ dpid: string; id: string }>();
  const userInfo = useUserInfo();

  if (!dpid || !tsId) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  const { loading, error } = useSetOrg(dpid);

  if (loading || userInfo.isLoading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopBar />
      <DocumentContextProvider>
        <TrainingSetDetails />
      </DocumentContextProvider>
    </Box>
  );
};
export default TrainingSetDetailsPage;
